import { ComponentProps } from "react";
import {
  FaBolt,
  FaHeart,
  FaInstagram,
  FaRegCommentDots,
} from "react-icons/fa";
import { OnboardLayout } from "components/OnboardLayout/OnboardLayout";

export const INSTAGRAM_GRADIENT =
  "linear-gradient(45deg, #feda75 0%, #fa7e1e 25%, #d62976 50%, #962fbf 75%, #4f5bd5 100%)";

/** Иллюстрация: логотип Instagram с «наклейками» — молния (автоответ), сообщение, сердечко */
export const InstagramIllustration = () => (
  <div className="relative w-[220px] h-[200px] sm:w-[280px] sm:h-[250px]">
    <div
      className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[140px] h-[140px] sm:w-[170px] sm:h-[170px] rounded-[40px] flex items-center justify-center text-white rotate-[-6deg]"
      style={{
        background: INSTAGRAM_GRADIENT,
        boxShadow:
          "0 0 0 8px rgba(255,255,255,0.12), 0 24px 60px rgba(214,41,118,0.45)",
      }}
    >
      <FaInstagram className="w-[84px] h-[84px] sm:w-[104px] sm:h-[104px]" />
    </div>
    <div className="absolute left-0 bottom-2 w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-white flex items-center justify-center shadow-xl rotate-[-10deg]">
      <FaBolt className="text-[#d62976] w-7 h-7 sm:w-9 sm:h-9" />
    </div>
    <div className="absolute right-0 top-2 w-14 h-14 sm:w-[68px] sm:h-[68px] rounded-2xl bg-white flex items-center justify-center shadow-xl rotate-[8deg]">
      <FaRegCommentDots className="text-[#4f5bd5] w-6 h-6 sm:w-8 sm:h-8" />
    </div>
    <div className="absolute right-3 bottom-0 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#e8f9b5] flex items-center justify-center shadow-xl rotate-[12deg]">
      <FaHeart className="text-[#962fbf] w-6 h-6 sm:w-7 sm:h-7" />
    </div>
  </div>
);

type InstagramConnectLayoutProps = ComponentProps<typeof OnboardLayout>;

/** Полноэкранный макет подключения Instagram: общий OnboardLayout с иллюстрацией Instagram */
export const InstagramConnectLayout = ({
  illustration = <InstagramIllustration />,
  ...props
}: InstagramConnectLayoutProps) => (
  <OnboardLayout illustration={illustration} {...props} />
);

export default InstagramConnectLayout;
